import React from 'react';
import { Button, message } from 'antd';
import { CrossIcon, TimelineCreateIcon } from '@icons';

export function showNewAssetVersionToast(
  assetId: string,
  onGoToLatestVersion: () => void
) {
  message.info({
    key: `new-version-${assetId}`,
    content: (
      <div className="message-dark-modal-content">
        <div>
          <div className="message-dark-modal-text">New version detected</div>
          <div className="message-dark-modal-text">
            <Button
              type="primary"
              onClick={() => {
                message.destroy(`new-version-${assetId}`);
                onGoToLatestVersion();
              }}
            >
              Go to the latest version
            </Button>
          </div>
        </div>
        <CrossIcon
          onClick={() => message.destroy(`new-version-${assetId}`)}
          className="message-dark-modal-close-btn"
        />
      </div>
    ),
    duration: 10,
    className: 'message-dark-modal b-with-button',
    icon: <TimelineCreateIcon className="anticon" />
  });
}
